export type Locale = (typeof supportedLocales)[number]

export const supportedLocales = [
  'en', // English 英语
  'zh', // Simplified Chinese 简体中文
  'es', // Spanish 西班牙语
  'ja', // Japanese 日语
  'fr', // French 法语
  'de', // German 德语
  'ko', // Korean 韩语
  'hi', // Hindi 印地语
  'ar', // Arabic (العربية) 阿拉伯语是从右到左（RTL - Right to Left）
  'bn', // Bengali 孟加拉语
  'pt', // Portuguese 葡萄牙语
  'ru', // Russian 俄语
  'vi', // Vietnamese 越南语
  'it', // Italian 意大利语
  'tr', // Turkish 土耳其语
  'th', // Thai 泰语
] as const

export const defaultLocale: Locale = 'en'

export const supportedLocalesForAi = {
  en: 'English',
  zh: 'Simplified Chinese',
  es: 'Spanish',
  ja: 'Japanese',
  fr: 'French',
  de: 'German',
  ko: 'Korean',
  hi: 'Hindi',
  ar: 'Arabic',
  bn: 'Bengali',
  pt: 'Portuguese',
  ru: 'Russian',
  vi: 'Vietnamese',
  it: 'Italian',
  tr: 'Turkish',
  th: 'Thai',
}
